<template>
  <div>
    <div class="has-background-white is-padding-bottom is-padding-top is-padding-right is-padding-left">
      <div class="title is-5 is-uppercase">
        <b>TEXTE ACCUEIL</b>
        <span
          class="is-padding-left-xsmall"
          v-helper.bottom="'5qq38tPKnRPJka9x56sQiQ'">
          <i class="fal fa-info-circle"></i>
        </span>
      </div>
    </div>
    <div class="has-background-white is-padding-right is-padding-left is-padding-bottom">
      <wysiwyg-editor
        :light="true"
        :tooltip-top="true"
        :model="welcom_text"
        @change="val => welcom_text = val"
        class="editr--bottom-toolbar no-toolbar editr--height-small content">
      </wysiwyg-editor>
    </div>
    <div class="has-background-white is-padding-bottom is-padding-top is-padding-right is-padding-left">
      <div class="title is-5 is-uppercase">
        <b>Coordonnées Référents</b>
        <span
          class="is-padding-left-xsmall"
          v-helper.bottom="'2KycTtS3OMCDs5lHGfI5qZ'">
          <i class="fal fa-info-circle"></i>
        </span>
      </div>
    </div>
    <div class="is-padding has-background-white">
      <template v-for="(contact, idx) in contacts">
        <template v-if="idx >= 1">
          <div
            :key="'referentSupp' +idx"
            class="columns is-vcentered"
            :class="{'is-border-top' : idx >= 1}">
            <div class="column">
              <div class="title is-6 is-uppercase">
                <b>Référent supplémentaire</b>
              </div>
            </div>
            <div
              class="column is-narrow is-paddingless"
              style="margin-top: -1px">
              <a
                @click.prevent.stop="contacts.splice(idx, 1)"
                class="button is-square is-action is-radiusless">
                <i class="fal fa-trash-alt"></i>
              </a>
            </div>
          </div>
        </template>
        <div
          :key="idx"
          class="columns is-multiline is-padding-bottom">
          <div class="column is-3">
            <v-input
              :id="`last_name_${idx}`"
              :name="`last_name_${idx}`"
              @input="val => contact.last_name = val"
              :model="contact.last_name"
              :errors-bag="errors"
              v-validate="'required|min:2'"
              data-vv-value-path="val"
              data-vv-as="Prénom">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Nom'"
                :value="contact.last_name"></r-label>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              :id="`first_name_${idx}`"
              :name="`first_name_${idx}`"
              @input="val => contact.first_name = val"
              :model="contact.first_name"
              :errors-bag="errors"
              v-validate="'required|min:2'"
              data-vv-value-path="val"
              data-vv-as="Prénom">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Prénom'"
                :value="contact.first_name"></r-label>
            </v-input>
          </div>
          <div class="column is-6">
            <v-input
              :id="`role_${idx}`"
              :name="`role_${idx}`"
              @input="val => contact.role = val"
              :model="contact.role"
              :errors-bag="errors"
              v-validate="'required|min:2'"
              data-vv-value-path="val"
              data-vv-as="Fonction">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Fonction'"
                :value="contact.role"></r-label>
            </v-input>
          </div>
          <div class="column is-3">
            <v-input
              :name="`email_${idx}`"
              :id="`email_${idx}`"
              :classes-input="'is-fullwidth'"
              @input="val => contact.email = val"
              :model="contact.email"
              :errors-bag="errors"
              v-validate="'required|min:3|max:255|email'"
              data-vv-value-path="val"
              data-vv-as="Mail"
              :has-addons="true">
              <r-label
                slot="label"
                :is-required="true"
                :label="'Mail'"
                :value="contact.email"></r-label>
              <p
                class="control"
                slot="addonLeft">
                <a class="button is-square is-static is-border">
                  <span class="icon"><i class="fas fa-paper-plane"></i></span>
                </a>
              </p>
            </v-input>
          </div>
          <div class="column is-3">
            <r-label
              :label="'Téléphone'"
              :value="contact.phone"
              :red-check="false"
              :truncate="false">
              <span
                class="is-padding-left-xsmall"
                v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                <i class="fal fa-info-circle"></i>
              </span>
            </r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-square">
                  <span class="icon"><i class="fas fa-phone-office"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input
                  id="contactPhone"
                  name="contactPhone"
                  @input="val => contact.phone = val"
                  :model="contact.phone"
                  :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                  v-validate="'required'"
                  :errors-bag="errors"
                  data-vv-value-path="val"
                  data-vv-as="Téléphone">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <r-label
              :label="'&nbsp;'"
              :is-required="false"></r-label>
            <div class="field is-margin-top-small">
              <input
                :id="`is_referent_${idx}`"
                v-model="contact.is_referent"
                :name="`is_referent_${idx}`"
                class="switch is-success is-rounded"
                type="checkbox">
              <label
                :for="`is_referent_${idx}`"
                style="font-size: 12.5px"
                :class="!contact.is_referent ? 'has-text-grey' : ''"
                class="is-size-7">Référent acquéreurs sur ce programme
                <span
                  class="is-padding-left-xsmall"
                  v-helper.bottom="'7MOFQsk7dEkFhZ3hTUxRoI'">
                  <i class="fal fa-info-circle"></i>
                </span>
              </label>
            </div>
          </div>
        </div>
      </template>
      <button
        class="page-header-btn button is-dark is-fullwidth is-radiusless"
        @click="addContact">
        <span>Ajouter un référent</span>
      </button>
    </div>
    <submit-sticky-buttons
      @submit="submit"
      :loading="submitLoading"
      button-id="programForm"></submit-sticky-buttons>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'BuyerSpaceAffichage',
  props: {
    program: {
      type: Object
    }
  },
  data () {
    return {
      submitLoading: false,
      contacts: [],
      welcom_text: null,
      has_buyer_space: true
    }
  },
  computed: {
    ...mapState(['currentUser'])
  },
  created () {
    if (this.program.buyer_space_data.welcom_text) {
      this.welcom_text = this.program.buyer_space_data.welcom_text
    } else {
      this.welcom_text = `<b>Bonjour</b> et <b>bienvenue</b> sur votre espace <b>${this.currentUser.account.name}</b>,<br>Nous vous remercions pour votre acquisition sur le programme <b>${this.program.name}</b>. La rubrique fil d'actualité vous permet de suivre l'avancement du projet. Nous restons à votre entière disposition pour répondre à vos questions et vous accompagner au mieux sur le suivi de votre projet.`
    }
    if (!this.program.buyer_space_data.contacts.length) {
      this.contacts.push({
        last_name: null,
        first_name: null,
        email: null,
        phone: null,
        role: null,
        is_referent: false
      })
    } else {
      this.contacts = this.program.buyer_space_data.contacts
    }
  },
  methods: {
    async submit () {
      let payload = {
        buyer_space_data: {
          contacts: this.contacts,
          welcom_text: this.welcom_text
        }
      }
      this.$emit('patchProgram', payload)
    },
    addContact () {
      this.contacts.push({
        last_name: null,
        first_name: null,
        email: null,
        phone: null,
        role: null,
        is_referent: false
      })
    }
  }
}
</script>
